<header class="h-14 bg-white dark:bg-brand-surface border-b border-brand-border flex items-center px-8 shrink-0 justify-between transition-colors">
  <div class="flex items-center">
    <button (click)="layoutService.toggleSidebar()" (keydown.enter)="layoutService.toggleSidebar()" class="material-symbols-outlined text-gray-400 dark:text-slate-400 mr-4 cursor-pointer focus:outline-none" aria-label="Alternar menu">menu</button>
    <h1 class="text-md font-bold text-gray-800 dark:text-slate-200">Projetos</h1>
  </div>
  <div class="flex items-center space-x-6">
    <button (click)="themeService.toggle()" class="material-symbols-outlined text-gray-400 dark:text-slate-400 hover:text-brand-primary dark:hover:text-brand-primary cursor-pointer focus:outline-none transition-colors" aria-label="Alternar tema">
      {{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}
    </button>
    <div class="relative">
      <span class="material-symbols-outlined text-gray-400 dark:text-slate-400 hover:text-brand-primary cursor-pointer">notifications</span>
      <span class="absolute -top-1 -right-1 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white dark:ring-slate-800"></span>
    </div>
  </div>
</header>
